import { useCallback, useEffect, useMemo, useRef, useState } from "react";
import { Box, Container, Grid } from "@mui/material";
import { NumberInTable, TypographyHead } from "./announceStyle";
import InputTextField from "../../component/input/inputTextField";
import AutocompleteSelect from "../../component/select/autoCompleteSelect";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import { FileRejection, useDropzone } from "react-dropzone";
import { useTranslation } from "react-i18next";
import upload from "../../assets/images/upload.png";

import VisibilityIcon from "@mui/icons-material/Visibility";
import { faTrashAlt } from "@fortawesome/free-solid-svg-icons";
import DeleteIcon from "@mui/icons-material/Delete";
import ButtonCustom from "../../component/button/buttonCustom";
import TableRowCommon from "../../component/table/TableRowCommon";

import TableCustom from "../../component/table/tableCustom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import * as Style from "./announceStyle";
import StallPicker from "./components/StallPicker";
import AnnounceLinks, {
  AnnounceLinkItem,
  createLinkRow,
  mapAnnounceLinks,
  toLinksPayload,
  validateLinks,
} from "./components/AnnounceLinks";
import {
  ANNOUNCE_ACCEPT_FILE,
  ANNOUNCE_MAX_FILES,
  ANNOUNCE_MAX_FILE_SIZE,
  announceRejectMessage,
  announceSaveResultMessage,
  mergeDroppedFiles,
  syncAnnounceFiles,
} from "./components/announceFile.utils";
import { getApiErrorMessage, getApiErrorStatus } from "../../utils/api-error.utils";
import InputNewRangePicker from "../../component/input/InputRangePicker";
import moment from "moment";
import {
  notiError,
  notiSuccess,
} from "../../component/notification/notifications";
import { Col } from "react-bootstrap";
import NewsTypeApi from "../../api/setting/news/news.api";
import AnnounceApi from "../../api/home/announce.api";
import ZoneApi from "../../api/zone/zone.api";
import StallTypeApi from "../../api/setting/stall/stall.api";
import FileuploadApi from "../../api/uploadfile/upload.api";
import Loading from "../../component/loading/loading";
import { useHistory, useLocation } from "react-router-dom";
import { getBranch } from "../../utils/app.utils";
import { stallLabelOf } from "../../utils/stall.utils";

const initStateErrorMessage = {
  PRFIX_NAME: ``,
  ROLDID: ``,
  NAME: ``,
  EMPLOYEE_CODE: ``,
  LASTNAME: ``,
  PHONE_NUBER: ``,
  EMAIL: ``,
  USERNAME: ``,
  PASSOWORD: ``,
  CONFIRM_PASSWORD: ``,
  BARNCH: ``,
  PW: ``,
  IDCARD: ``,
  HEAD: ``,
};

export default function AddAnnounceRental() {
  const location: any = useLocation();
  const history = useHistory();

  const type: any = location?.state?.type
  const id: any = location?.state?.id
  const branchId: any = getBranch() ? Number(getBranch()) : undefined

  const [file, setFile] = useState<any[]>([]);
  const [mapData, setMapData] = useState<any[]>([]);
  const [stallTypeList, setStallTypeList] = useState<any[]>([]);
  const [title, setTitle] = useState<string>("");
  const [detail, setDetail] = useState<string>("");
  const [status, setStatus] = useState<string>("");
  // const [newType, setNewtype] = useState<any[]>([]);

  const [dataTable, setDataTable] = useState<any[]>([]);
  const [newstypeId, setNewTyperId] = useState<number>(1);
  const [errorMessage, setErrorMessage] = useState<any>(initStateErrorMessage);
  const [selectedDateRange, setSelectedDateRange] = useState<string[]>([]);
  const [dateStart, setDateStart] = useState<any>([]);
  const [dateEnd, setDateEnd] = useState<string>("");
  const [loading, setLoading] = useState<boolean>(false);

  const [select, setSelectfile] = useState<any>();
  const [links, setLinks] = useState<AnnounceLinkItem[]>([createLinkRow()]);
  const [linkErrors, setLinkErrors] = useState<{ [rowId: string]: string }>({});
  /** ไฟล์เดิมที่ผู้ใช้กดถอดออก — ยังไม่ยิงลบ รอกดบันทึกก่อน ถ้าออกจากหน้าไปเลยไฟล์จะไม่ถูกลบ */
  const [deletedFiles, setDeletedFiles] = useState<any[]>([]);
  const [isSubmitting, setIsSubmitting] = useState<boolean>(false);
  /** กันกดปุ่มรัวก่อน isSubmitting จะ re-render ทัน */
  const isSubmittingRef = useRef<boolean>(false);
  const { t } = useTranslation();

  const handleClearRangeDate = () => {
    setSelectedDateRange([]);
    setDateStart("");
    setDateEnd("");
  };

  /** stallId ที่อยู่ในตะกร้าแล้ว — ส่งให้ picker ไปปิดการติ๊กซ้ำ */
  const basketIds = useMemo(
    () => dataTable.map((d: any) => d?.stallId).filter((stallId: any) => stallId != null),
    [dataTable]
  );

  /** GET zone/list ส่งมาแค่ stallTypeId ไม่มี object stallType
   *  จึงต้องดึงตารางประเภทแผงค้ามาแปลงชื่อเอง */
  const stallTypeNameById = useMemo(() => {
    const dict: Record<number, string> = {};
    stallTypeList.forEach((item: any) => {
      if (item?.stallTypeId != null) dict[item.stallTypeId] = item?.stallTypeNameTh || "";
    });
    return dict;
  }, [stallTypeList]);

  const handleAddStalls = useCallback(
    (stalls: any[], zoneName: string) => {
      setDataTable((prev: any[]) => {
        const existing = new Set(prev.map((d: any) => d?.stallId));
        const additions = stalls
          .filter((s: any) => s?.stallId != null && !existing.has(s.stallId))
          /** สร้าง object ใหม่ ไม่ใช่ตัวที่อยู่ใน mapData
           *  ของเดิมใช้ Object.assign เขียนทับแผงใน mapData ทำให้ราคา/ชื่อโซน
           *  ที่พิมพ์ในตะกร้าไหลย้อนกลับไปโผล่ในผังด้วย */
          .map((s: any) => ({
            stallId: s.stallId,
            stallName: s.stallName,
            stallNumber: s.stallNumber,
            // เติมชื่อประเภทให้เอง เพราะ zone/list ส่งมาแค่ stallTypeId
            stallType:
              s.stallType ||
              (s.stallTypeId != null
                ? {
                    stallTypeId: s.stallTypeId,
                    stallTypeNameTh: stallTypeNameById[s.stallTypeId] || "",
                  }
                : null),
            status: s.status,
            zoneName: zoneName,
            bidTypeId: undefined,
            price: "",
          }));
        return additions.length ? [...prev, ...additions] : prev;
      });
    },
    [stallTypeNameById]
  );
  const handleDelete = async (x: any) => {
    setDataTable(dataTable.filter((item: any) => item.stallId !== x));
  };
  const handlepreview = (x: any) => {
    // let name = ''
    // if (x?.refId) {
    //   name = x?.fileName?.split(".")
    // } else {
    //   name = x?.type?.split(".")
    // }

    // if (name[name?.length - 1] === "application/pdf") {
    //   window.open(URL.createObjectURL(x), "_blank");
    // } else {
    //   setSelectfile(URL.createObjectURL(x));
    // }
    if (x?.filePath && x?.fileName) {
      if (x.mimetype === "application/pdf") {
        window.open(process.env.REACT_APP_FILE_URL +
          x?.filePath +
          x?.fileName, "_blank");
      } else {
        setSelectfile(process.env.REACT_APP_FILE_URL +
          x?.filePath +
          x?.fileName);
      }
    } else {
      const name = x.type.split(".");

      if (name[name?.length - 1] === "application/pdf") {
        window.open(URL.createObjectURL(x), "_blank");
      } else {
        setSelectfile(URL.createObjectURL(x));
      }
    }

  };
  const handleRangeDate = (value: any) => {
    setSelectedDateRange(value);
    setDateStart(moment(value[0]).format("YYYY-MM-DD"));
    setDateEnd(moment(value[1]).format("YYYY-MM-DD"));
  };
  // const handleRangeDate = (value: any, obj: any) => {
  //   Object.assign(obj, { startDate: moment(value[0]).format("YYYY-MM-DD") });
  //   Object.assign(obj, { endDate: moment(value[1]).format("YYYY-MM-DD") });
  //   Object.assign(obj, { selectedDateRange: value });
  //   setSelectedDateRange(value);
  // };
  /**
   * ถอดไฟล์ออกจากฟอร์มเท่านั้น ยังไม่ยิงลบ — ไฟล์ที่บันทึกไว้แล้ว (มี fileId) เข้าคิวไว้
   * รอกดบันทึกจึงลบจริง ถ้าผู้ใช้ออกจากหน้าไปเลยไฟล์ยังอยู่ครบ
   */
  const handledeleteImg = (x: any) => {
    const target = file[x];
    if (target?.fileId) setDeletedFiles((prev: any[]) => [...prev, target]);
    setFile(file.filter((y: any, index: number) => x !== index));
    setSelectfile(null);
  };

  /** logic อยู่ใน announceFile.utils.ts เพราะฟอร์มประกาศทั่วไปใช้ชุดเดียวกัน */
  const handleAnnounceFiles = (res: any) =>
    syncAnnounceFiles({
      res,
      files: file,
      deletedFiles,
      announceId: id,
      deleteFile: FileuploadApi.deleteFile.bind(FileuploadApi),
      uploadFiles: FileuploadApi.uploadfilearray.bind(FileuploadApi),
      errorStatus: getApiErrorStatus,
    });
  // const handleClearRangeDate = (x: any) => {
  //   Object.assign(x, { selectedDateRange: [] });
  //   setDateStart("");
  //   setDateEnd("");
  // };

  // const getnewType = async () => {
  //   const codition = {
  //     page: 1,
  //     pageLimit: 50,
  //     announceType: "RENT",
  //   };
  //   await NewsTypeApi.findAll(codition).then((res) => {
  //     if (res.status === 200) {
  //       setNewtype(res?.data);
  //     }
  //   });
  // };

  const getDetail = async () => {
    await AnnounceApi.details(id).then((res) => {
      if (res?.status === 200) {
        const data: any = res?.data
        setDataTable(data?.round?.map((item: any) => {
          return {
            ...item,
            zoneName: item?.stall?.zone?.zoneName,
            stallName: item?.stall?.stallName,
            // ยกขึ้นมาไว้ใช้เป็นตัวสำรองตอน stallName ว่าง
            stallNumber: item?.stall?.stallNumber,
            stallType: item?.stall?.stallType
          }
        }) || [])
        setDetail(data?.detail || '')
        setDateStart(data.startDate)
        setDateEnd(data.endDate)
        setNewTyperId(data?.newstypeId)
        setTitle(data?.title)
        setFile(data?.fileUpload || [])
        const dataLinks = mapAnnounceLinks(data?.announceLinks);
        setLinks(dataLinks.length ? dataLinks : [createLinkRow()]);
        setSelectedDateRange([
          `${moment(data?.startDate)}`, `${moment(data?.endDate)}`
        ])

        setStatus(data?.status)

      }
    });
  }

  useEffect(() => {
    if (id) {
      getDetail()
    }
  }, [])

  /** ตารางประเภทแผงค้า ใช้แปลง stallTypeId -> ชื่อ (zone/list ไม่ส่ง relation มาให้) */
  const loadStallType = useCallback(async () => {
    await StallTypeApi.findAll({
      page: 1,
      pageLimit: 50,
      sortBy: "modifiedDate",
      sortType: "ASC",
      status: "ACTIVE",
    })
      .then((res) => {
        if (res.status === 200) setStallTypeList(res.data || []);
      })
      .catch(() => setStallTypeList([]));
  }, []);

  useEffect(() => {
    loadStallType();
  }, [loadStallType]);

  const loadData = useCallback(async () => {
    setLoading(true)
    let condition: any = {
      page: 1,
      pageLimit: 4000,
      branchId: branchId,
      // 0 = ข้ามการคำนวณ ไม่แนบ meterNumber[].utilities ซึ่งหน้าเลือกแผงไม่ได้ใช้
      skipcalculation: 0
    };
    // ดึงทั้งสาขามาครั้งเดียว แล้วให้ StallPicker ค้นหา/กรอง/แบ่งหน้าฝั่ง client
    // (เดิมผูก search/leasesTypeId ไว้กับ deps ทำให้ edit mode ยิง 4,000 rows ซ้ำสองรอบ)

    await ZoneApi.list(condition).then((res) => {
      if (res.status < 300) {
        setMapData(res.data);
        setLoading(false)
      }
    }).catch((err) => {
      console.log(err);
      setMapData([]);
      setLoading(false)
    }).finally(() => {
      setLoading(false)
    })

    // if (res.status === 200) {
    //   setMapData(res.data);
    //   setLoading(false)
    // } else if (res.status === 400) {
    //   setMapData([]);
    //   setLoading(false)
    // } else {
    //   setMapData([]);
    //   setLoading(false)
    // }
  }, [branchId]);

  useEffect(() => {
    loadData();
  }, [loadData]);
  // const prefixData = [
  //   { bidTypeId: 1, label: "ราคาเช่า" },
  //   { bidTypeId: 2, label: "ประมูล" },
  // ];
  const onDrop = useCallback(
    (acceptedFiles: File[]) => {
      if (!acceptedFiles?.length) return;
      const { files, duplicated, overflow } = mergeDroppedFiles(file, acceptedFiles);
      if (duplicated) notiError("ไฟล์นี้ถูกแนบไว้แล้ว", "", null, null);
      if (overflow)
        notiError(`แนบไฟล์ได้ไม่เกิน ${ANNOUNCE_MAX_FILES} ไฟล์`, "", null, null);
      setFile(files);
    },
    [file]
  );

  const onDropRejected = useCallback((rejections: FileRejection[]) => {
    notiError(announceRejectMessage(rejections), "", null, null);
  }, []);

  const { getRootProps, getInputProps } = useDropzone({
    onDrop,
    onDropRejected,
    accept: ANNOUNCE_ACCEPT_FILE,
    multiple: true,
    maxSize: ANNOUNCE_MAX_FILE_SIZE,
  });

  const handleSubmit = async () => {
    if (!newstypeId)
      return setErrorMessage({
        ...errorMessage,
        ...{ HEAD: t(`ANNOUNCE.NOTI.HEAD`) },
      });
    const errorLinks = validateLinks(links);
    if (Object.keys(errorLinks).length > 0) {
      setLinkErrors(errorLinks);
      return notiError(`${t("ANNOUNCE.NOTI.LINK")}`, "", null, null);
    }
    setLinkErrors({});

    if (isSubmittingRef.current) return;
    isSubmittingRef.current = true;
    setIsSubmitting(true);

    const condition = {
      newstypeId: newstypeId,
      title: title,
      detail: detail,
      // branchId:branchId,
      bookmark: false,
      announceType: "RENT",
      status: "PENDING",
      // startDate: moment(new Date()).format("YYYY-MM-DD"),
      startDate: dateStart ? moment(dateStart).format("YYYY-MM-DD") : null,
      endDate: dateEnd ? moment(dateEnd).format("YYYY-MM-DD") : null,
      // file: file,
      round: dataTable?.map((obj: any) => {
        return {
          startDate: dateStart ? moment(dateStart).format("YYYY-MM-DD") : null,
          endDate: dateEnd ? moment(dateEnd).format("YYYY-MM-DD") : null,
          stallId: obj.stallId,
          bidTypeId: obj.bidTypeId,
          // ฝั่งผู้ประกอบการไม่มีแล้ว พี่อ้ายให้เอาออก
          price: 0,
          // price: parseInt(obj.price),
        };
      }),
      // links เป็น replace-all: ส่งทั้งชุดทุกครั้ง, [] = ลบลิงก์เดิมทั้งหมด
      links: toLinksPayload(links),
    };

    try {
      const res = id
        ? await AnnounceApi.updateAnnounce(condition, id)
        : await AnnounceApi.createAnnounce(condition);

      if (id ? res.status >= 300 : res.status !== 201) {
        return notiError(
          id ? 'บันทึกประกาศแผงค้าไม่สำเร็จ' : 'สร้างประกาศแผงค้าไม่สำเร็จ',
          "",
          null,
          null
        );
      }

      // ไฟล์แนบไม่ throw แล้ว คืนสรุปผลมาให้เลือกข้อความ — record บันทึกสำเร็จไปแล้ว
      // ถ้าปล่อยให้ error ทะลุออกไป ผู้ใช้จะเข้าใจว่าบันทึกไม่สำเร็จแล้วกดซ้ำจนได้ประกาศซ้ำ
      const fileResult = await handleAnnounceFiles(res);
      // เคลียร์คิวลบ กันยิงลบซ้ำถ้าผู้ใช้กดบันทึกอีกรอบก่อนออกจากหน้า
      setDeletedFiles([]);

      const { message, warn } = announceSaveResultMessage(
        id ? `อัพเดตข้อมูลสำเร็จ` : `${t("ANNOUNCE.NOTI.SUCESS")}`,
        fileResult
      );
      if (warn) {
        // ไม่ผูก navigate กับ option "go" เพราะมันทำงานตอน toast ปิด (หน่วง 3 วิ) ผู้ใช้อาจกดไปหน้าอื่นไปแล้ว
        notiError(message, "", null, null);
        history.push("/announce");
      } else {
        notiSuccess(message, "go", "/announce", null, undefined, history);
      }
    } catch (error) {
      notiError(getApiErrorMessage(error, "บันทึกข้อมูลไม่สำเร็จ"), "", null, null);
    } finally {
      isSubmittingRef.current = false;
      setIsSubmitting(false);
    }
  };


  const headCells = [
    {
      id: "no",

      label: (
        <div
          className="d-flex flex-row justify-content-between"
          style={{ minHeight: 48, alignItems: "center", padding: "0px 10px" }}
        >
          <div>{t("STALL.TABLE.LIST")}</div>
          <div>{t("STALL.TABLE.SELECT") + t("STALL.TABLE.UNIT")}</div>
        </div>
      ),
      align: "left",
      colSpan: 9,
    },
  ];
  const renderData = (objData: any, index: number) => {
    const no = index + 1;
    const {
      date,
      price,
      status,
      stallName,
      stallNumber,
      stallType,
      zoneName,
      stall,
      stallId,
    } = objData;

    /** หลายแผงมี stallName เป็นค่าว่าง — helper จะเหลือเฉพาะเลขแผงให้เอง ไม่ปล่อยวงเล็บว่าง */
    const stallLabel = stallLabelOf(stallNumber, stallName);
    const stallTypeLabel =
      stallType?.stallTypeNameTh || stallTypeNameById[stallType?.stallTypeId] || "-";

    const objRenderData = {
      key: `${index}`,
      id: `${index}`,
      obj: objData,
      columns: [
        {
          option: "COMPONENT",
          align: "center",
          component: <NumberInTable>{no}</NumberInTable>,
        },
        {
          option: "TEXT",
          align: "left",
          label: t("STALL.ROW.ZONE") + (zoneName || "-")
        },
        {
          option: "TEXT",
          align: "left",
          label: t("STALL.ROW.STALL") + stallLabel,
        },
        {
          option: "TEXT",
          align: "left",
          label: t("STALL.ROW.TYPE_STALL") + stallTypeLabel,
        },
        // {
        //   option: "COMPONENT",
        //   align: "left",
        //   component: (
        //     <AutocompleteSelect
        //       labelId="announcerental"
        //       options={prefixData}
        //       onChange={(e, newvalue) => {
        //         Object.assign(objData, { bidTypeId: newvalue?.bidTypeId });
        //       }}
        //     />
        //   ),
        //   width: "15%",
        // },

        // {
        //   option: "COMPONENT",
        //   align: "left",
        //   component: (
        //     <InputTextField
        //       label={'ราคาเช่า'}
        //       value={price || ''}
        //       onchange={(e) => {
        //         const value = e.target.value;
        //         setDataTable((prev: any[]) =>
        //           prev.map((item: any, i: number) =>
        //             i === index ? { ...item, price: value } : item
        //           )
        //         );
        //       }}
        //     />
        //   ),
        //   width: "15%",
        // },

        // {
        //   option: "TEXT",
        //   align: "left",
        //   label: t("ANNOUNCE.TABLEHEAD.DATE_TIME"),
        // },
        // {
        //   option: "COMPONENT",
        //   align: "left",
        //   component: (
        //     <InputNewRangePicker
        //       key={"date-appointment"}
        //       label={t("REPAIR_TYPE_MANGEMENT.INPUT.START_END_DATE")}
        //       value={selectedDateRange}
        //       onClear={() => handleClearRangeDate(objData)}
        //       onchange={(value) => handleRangeDate(value, objData)}
        //       disablePast={true}
        //     />
        //   ),
        //   width: "20%",
        // },
        {
          option: "COMPONENT",
          align: "left",
          width: 50,
          component: (
            <FontAwesomeIcon
              icon={faTrashAlt}
              style={{ cursor: "pointer" }}
              onClick={() => handleDelete(stallId)}
              color="red"
            />
          ),
        },
      ],
    };
    return <TableRowCommon {...objRenderData} />;
  };
  // useEffect(() => {
  //   getnewType();
  // }, []);

  function getBase64(file: any) {
    return new Promise((resolve, reject) => {
      const reader: any = new FileReader();

      reader.onload = () => {
        const base64String = reader.result.split(",")[1];
        resolve(base64String);
      };

      reader.onerror = (error: any) => {
        reject(error);
      };

      reader.readAsDataURL(file);
    });
  }

  const uploadAdapter = (loader: any) => {

    return {
      upload: async () => {
        const file = await loader.file;
        const base64 = await getBase64(file);
        return {
          default: "data:image/jpeg;base64," + base64,
        };
      },
    };
  };

  function uploadPlugin(editor: any) {
    editor.plugins.get("FileRepository").createUploadAdapter = (loader: any) => {
      return uploadAdapter(loader);
    };
  }

  return (
    <Box className='mb-5'>
      <Style.headerannoce>
        <TypographyHead>{t("ANNOUNCE.HEAD.ADDANNOUNCE")}</TypographyHead>
      </Style.headerannoce>
      <Style.boxcontainer>
        <Style.boxinsite>
          <Box sx={{ display: "flex", alignItems: "center" }}>
            <Grid container spacing={2}>
              <Grid item lg={2} xs={12}>
                {t("ประเภทประกาศ")}
                {/* {t("ANNOUNCE.CREATE.NEW_TYPE")} */}
              </Grid>
              <Grid item lg={10} xs={12}>
                {/* <AutocompleteSelect
                  options={newType}
                  required={true}
                  value={
                    newstypeId
                      ? newType.find(
                        (data: any) => data.newstypeId === newstypeId
                      )
                      : null
                  }
                  getOptionLabel={(option: any) => option.newstypeNameTh}
                  // onChange={(data: any) => setPrefixId(data.value)}
                  onChange={(event, newValue) => {
                    if (newValue) {
                      setNewTyperId(newValue.newstypeId);
                    }
                  }}
                  helperText={errorMessage.HEAD}
                  labelId="add"
                /> */}
                ประเภทเช่าแผงค้า
              </Grid>
              <Grid item lg={2} xs={12}>
                {t("ANNOUNCE.CREATE.HEAD")}
              </Grid>
              <Grid item lg={10} xs={12}>
                <InputTextField value={title} onchange={(e) => setTitle(e.target.value)} />
              </Grid>
              <Grid item lg={2} xs={12}>
                {t("ระยะเวลาการประกาศ")}
              </Grid>
              <Grid item lg={10} xs={12}>
                <InputNewRangePicker
                  key={"date-appointment"}
                  label={t("วันที่เริ่มต้นใช้งาน และสิ้นสุดการใช้งาน")}
                  value={selectedDateRange}
                  onClear={handleClearRangeDate}
                  onchange={handleRangeDate}

                />
              </Grid>
              <Grid item lg={2} xs={12}>
                {t("ANNOUNCE.CREATE.DETAILCREATE")}
              </Grid>
              <Grid item lg={10} xs={12}>

                <div style={{ width: "100%" }}>
                  <CKEditor
                    editor={ClassicEditor}
                    onReady={(editor) => {
                    }}
                    onChange={(event, editor) => {
                      const data = editor.getData();
                      setDetail(data);
                    }}
                    data={detail || ''}
                    config={{
                      extraPlugins: [uploadPlugin],
                      toolbar: {
                        items: [
                          'heading',
                          '|',
                          'bold',
                          'italic',
                          '|',
                          'bulletedList',
                          'numberedList',
                          '|',
                          'insertTable',
                          '|',
                          'imageUpload',
                          '|',
                          'undo',
                          'redo'
                        ]
                      },
                    }}

                  />
                </div>
              </Grid>
              <Grid item lg={12}>
                {t("ANNOUNCE.HEAD.STALL")}
              </Grid>

              <Grid item lg={12} xs={12}>
                <StallPicker
                  mapData={mapData}
                  basketIds={basketIds}
                  stallTypeNameById={stallTypeNameById}
                  onAddStalls={handleAddStalls}
                />
              </Grid>

              <Grid item lg={12} xs={12}>
                <TableCustom
                  headCells={headCells}
                  customScroll
                  page={1}
                  pageLimit={1}
                  sortType={"ASC"}
                  sortBy=""
                  rowCount={1}
                  tableMinWidth={1000}
                  rowsData={dataTable?.map((d: any, index: any) => {
                    return renderData(d, index);
                  })}
                  onSort={() => { }}
                  setPageLimit={() => { }}
                  setPage={() => { }}
                  hidePagination
                />
              </Grid>
            </Grid>
          </Box>

          <Box sx={{ marginTop: "43px" }}>
            <Container maxWidth="lg">
              <Grid container spacing={2}>
                <Grid item lg={1} xs={12}>
                  {t("ANNOUNCE.CREATE.FILE")}
                </Grid>
                <Grid item lg={11} xs={12}>
                  <Style.boxupload>
                    {" "}
                    <div {...getRootProps()}>
                      <input type="file" multiple {...getInputProps()} />
                      {select ? (
                        <img
                          src={select}
                          alt="Thumb"
                          style={{ width: "100%", height: "250px", cursor: "pointer", }}
                        />
                      ) : (
                        <img src={upload} style={{ width: "100%", cursor: "pointer" }} />
                      )}
                    </div>
                  </Style.boxupload>
                </Grid>

                {file?.map((e: any, index: any) => (
                  <>
                    {/* <Col item lg={1} xs={12}></Col> */}
                    <Col item lg={2} xs={12} className="my-2 d-flex align-items-center">
                      ไฟล์แนบลำดับที่ {index + 1}
                    </Col>
                    <Col item lg={10} xs={12} className="my-2">
                      <Style.filearray>
                        <Box
                          sx={{
                            display: "flex",
                            justifyContent: "space-between",
                          }}
                        >
                          <Box>{e?.name || e?.fileName}</Box>
                          <Box>
                            <VisibilityIcon
                              onClick={() => handlepreview(e)}
                              sx={{ cursor: "pointer", marginRight: "10px" }}
                            />
                            <DeleteIcon
                              onClick={() => handledeleteImg(index)}
                              color="error"
                              sx={{ cursor: "pointer" }}
                            />
                          </Box>
                        </Box>
                      </Style.filearray>
                    </Col>
                  </>
                ))}

                <Grid item lg={1} xs={12}>
                  {t("ANNOUNCE.CREATE.LINK")}
                </Grid>
                <Grid item lg={11} xs={12}>
                  <AnnounceLinks
                    links={links}
                    onChange={setLinks}
                    errors={linkErrors}
                  />
                </Grid>

                <Grid item lg={12} xs={12}>
                  <ButtonCustom
                    type="submit"
                    onClick={handleSubmit}
                    disabled={!dateStart || !dateEnd}
                    loading={isSubmitting}
                    loadingText="กำลังบันทึก..."
                    textButton={t("REGISTER.BUTTON.SUMMIT")}
                    btnStyle={{
                      fontSize: "16px",
                      width: "100%",
                      padding: "0px",
                      marginTop: "32px",
                      marginBottom: "14px",
                    }}
                  />
                </Grid>
              </Grid>
            </Container>
          </Box>
        </Style.boxinsite>
      </Style.boxcontainer>
      {loading && <Loading show={loading} type="fullLoading" />}
    </Box>
  );
}
